'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'classnames';
import PropTypes from 'prop-types';

import useDocumentVisibility from 'hooks/useDocumentVisibility';

import CarouselContext from './CarouselContext';

import styles from './CarouselProvider.module.scss';

const CarouselProvider = ({ slides = [], className, children, firstBlock }) => {
    const cleanSlides =
        slides?.filter(slide => {
            return slide.__typename !== undefined;
        }) || [];

    const ref = useRef(null);
    const documentVisibility = useDocumentVisibility();

    const intersection = useIntersection(ref, {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    });

    const [activeIndex, setActiveIndex] = useState(firstBlock ? 0 : null);
    const [prevIndex, setPrevIndex] = useState(null);
    const [firstSlideChangeOccurred, setFirstSlideChangeOccurred] =
        useState(false);

    const totalSlides = cleanSlides.length;

    const nextSlide = useCallback(() => {
        setFirstSlideChangeOccurred(true);
        setPrevIndex(activeIndex);
        setActiveIndex((activeIndex + 1) % totalSlides);
    }, [activeIndex, totalSlides]);

    const prevSlide = useCallback(() => {
        setFirstSlideChangeOccurred(true);
        setPrevIndex(activeIndex);
        setActiveIndex((activeIndex - 1 + totalSlides) % totalSlides);
    }, [activeIndex, totalSlides]);

    const slideChange = useCallback(
        direction => {
            direction === 'prev' ? prevSlide() : nextSlide();
        },
        [nextSlide, prevSlide]
    );

    const goToSlide = useCallback(
        index => {
            if (index === activeIndex) {
                return;
            }

            setFirstSlideChangeOccurred(true);
            setPrevIndex(activeIndex);
            setActiveIndex(index);
        },
        [activeIndex]
    );

    const handleClick = direction => () => {
        slideChange(direction);
    };

    useEffect(() => {
        const inView =
            documentVisibility === 'visible' && intersection?.isIntersecting;

        // Run intro animation once
        inView && activeIndex === null && setActiveIndex(0);
    }, [
        firstBlock,
        activeIndex,
        documentVisibility,
        intersection?.isIntersecting,
    ]);

    return (
        <section ref={ref} className={cx(styles.root, className)}>
            <CarouselContext.Provider
                value={{
                    activeIndex,
                    prevIndex,
                    totalSlides,
                    slides: cleanSlides,
                    firstSlideChangeOccurred,
                    nextSlide: handleClick('next'),
                    prevSlide: handleClick('prev'),
                    goToSlide,
                }}
            >
                {children}
            </CarouselContext.Provider>
        </section>
    );
};

CarouselProvider.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    firstBlock: PropTypes.bool,
    slides: PropTypes.array,
};

export default CarouselProvider;
